import { ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output, Self, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { PrimeTemplate, SelectItem } from 'primeng/api';
import { Select } from 'primeng/select';
import { AbstractControlToFormControlPipe } from '../../../pipes/abstract-control-to-form-control.pipe';
import { IconComponent } from '../../icon/icon.component';

@Component({
  selector: 'shared-select',
  imports: [FormsModule, ReactiveFormsModule, AbstractControlToFormControlPipe, IconComponent, Select, PrimeTemplate],
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class SelectComponent<T = unknown> {
  @Input() options: SelectItem<T>[] = [];
  @Input() placeholder = '';
  @Input() showClear = false;
  @Input() showFilter = false;
  @Input() filterPlaceholder = '';
  @Input() showLogo = true;

  /* eslint-disable @angular-eslint/no-output-on-prefix */
  @Output() onChange = new EventEmitter<SelectItem<T>>();
  @Output() onClear = new EventEmitter();
  /* eslint-enable @angular-eslint/no-output-on-prefix */

  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      // trick it into thinking control has a valueAccessor, we don't need it because child has
      this.ngControl.valueAccessor = {
        writeValue(): void {
          // do nothing
        },
        registerOnChange(): void {
          // do nothing
        },
        registerOnTouched(): void {
          // do nothing
        },
      };
    }
  }

  getItemById(id: string): SelectItem<T> | undefined {
    return this.options?.find((option) => option.value === id);
  }

  get areOptionsLoading(): boolean {
    return !this.options;
  }

  get optionsLoadedAndSelectFilled(): boolean {
    return !this.areOptionsLoading && !!this.ngControl.value;
  }

  get optionsLoadedAndSelectEmpty(): boolean {
    return !this.areOptionsLoading && (!this.ngControl.value || this.ngControl.value.length === 0);
  }

  clearSelect($event: unknown): void {
    this.ngControl.reset();
    this.onClear.emit($event);
  }
}
